<template>
    <div>
        <form @submit.prevent="submitFilters">
            <div class="row">

                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="date">From Date</label>
                    <b-form-group label-for="start_date" class="akkurate-dark">
                        <b-form-input id="start_date" class="mt-1 field-container fields" type="date"
                            v-model="form.start_date">
                        </b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="date">To Date</label>
                    <b-form-group label-for="end_date" class="akkurate-dark">
                        <b-form-input id="end_date" class="mt-1 field-container fields" type="date"
                            v-model="form.end_date">
                        </b-form-input>
                    </b-form-group>
                </div>

                <!-- <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="search">Transaction Type</label>
                    <b-form-group id="transaction_type" label-for="transaction_type" class="akkurate-dark">
                        <multiselect class="mt-2 field-container" v-model="form.transaction_type"
                            :options="transaction_types" selectLabel="" deselectLabel="">
                        </multiselect>
                    </b-form-group>
                </div> -->

                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="term">Terms</label>
                    <multiselect class="mt-1 field-container" v-model="form.term" :options="terms_option"
                        placeholder="Select one" selectLabel="" deselectLabel="">
                    </multiselect>
                </div>


                <!-- <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="branch">Branch</label>
                    <b-form-group id="branch" label-for="branch" class="akkurate-dark">
                        <multiselect v-model="form.branch" :options="branch_option" :multiple="true"
                            placeholder="Select Branch" :close-on-select="false" label="name" :clear-on-select="false"
                            class="mt-2 field-container" track-by="name">
                            <template slot="selection">
                                <span class="multiselect__single" v-if="form.branch.length">{{ form.branch.length }}
                                    options
                                    selected</span>
                            </template>
</multiselect>
<div class="akkurate-small">{{ getBranch }}</div>
</b-form-group>
</div> -->

                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="transaction_mode">Transaction Type</label>
                    <multiselect class="mt-1 field-container" v-model="form.entry_mode" :options="entry_mode_options"
                        placeholder="Select one" selectLabel="" deselectLabel="">
                    </multiselect>
                </div>
                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="model_type">Model Type<star></star></label>
                    <b-form-group id="model_type" label-for="model_type">
                        <multiselect id="model_type" name="model_type" class="mt-1 field-container"
                            placeholder="Select Mode" multiple="true" v-model="form.model_type" :options="model_options"
                            track-by="id" label="name">
                        </multiselect>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="global_reference">Global Reference</label>
                    <b-form-group label-for="global_reference" class="akkurate-dark">
                        <b-form-input id="global_reference" class="mt-1 field-container fields" type="text"
                            v-model="form.global_reference" placeholder="Enter Global Reference">
                        </b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="transaction_type">User(s)</label>
                    <multiselect class="mt-2 field-container" v-model="form.users" :options="users"
                        placeholder="Select User" selectLabel="" :custom-label="fullName" :close-on-select="false"
                        :clear-on-select="false" :multiple="true" deselectLabel="" :limit-text="limitText" :limit="1"
                        track-by="id">
                    </multiselect>
                </div>

                  <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="global_reference">COA Code</label>
                    <b-form-group label-for="coa_code" class="akkurate-dark">
                        <b-form-input id="coa_code" class="mt-1 field-container fields" type="text"
                            v-model="form.coa_code" placeholder="Enter COA Code">
                        </b-form-input>
                    </b-form-group>
                </div>

                  <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="coa_type">COA Type</label>
                    <multiselect class="mt-2 field-container" v-model="form.coa_type" :options="coa_type_options"
                        placeholder="Select COA Type" selectLabel="" label="name" :close-on-select="false"
                        :clear-on-select="false" :multiple="true" deselectLabel="" :limit-text="limitTextCOAType" :limit="1"
                        track-by="id">
                    </multiselect>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props: ['form', 'users', 'branch_option','coa_type_options'],
    // computed: {
    //     getBranch() {
    //         if (this.form.branch.length > 0) {
    //             const result = this.form.branch.map((index) => {
    //                 return index.name
    //             });
    //             return result.join(" | "); // Join array elements with ", "
    //         } else {
    //             return "";
    //         }
    //     }
    // },
    data() {
        return {
            more_details: false,
            // transaction_options: ['Deposit', 'Withdrawal'],
            // sources: ['Mobile', 'WEB', 'USSD']
            terms_option: ['YTD', 'Periodic', 'Trashed'],
            entry_mode_options: ['Debit', 'Credit'],
            // sources: [{ name: 'USSD', id: "USSD" }, { name: 'WEB', id: "WEB" }, { name: 'MOBILE BANKER', id: "Mobile_Banker" }],
            // code_option: [
            //   { name: "Customer code", value: "filter" },
            //   { name: "Account #", value: "account_number" },
            //   { name: "Ref.No", value: "code" },
            //   { name: "Mobile", value: "phone_number" },
            // ],
            trans_source_options: [
                { name: 'USSD', value: "ussd" },
                { name: 'OFFICE', value: "office" },
                { name: 'MOBILE', value: "mobile" },
                // { name: 'Deposit', value: "deposit" },
                // { name: 'Withdrawal', value: "withdrawal" },
            ],
            model_options: [
                { 'id': "App\\Models\\Transaction", "name": 'Transactions' },
                { 'id': "App\\Models\\Journal", "name": 'Journals' },
                { 'id': "App\\Models\\Voucher", "name": 'Vouchers' },
                { 'id': "App\\Models\\Loan", "name": 'Loans' },
                { 'id': "App\\Models\\FixedDepositProductScheme", "name": 'Fixed Deposits' },
                { 'id': "App\\Models\\COASubHead", "name": 'COA Subhead' },
            ]
            // trans_sources: ["Deposit", "Withdrawal"]

        }
    },
    methods: {
        submitFilters() {
            this.$emit("submitFilters");
        },



        show_more() {
            this.more_details = !this.more_details
        },
        fullName({ first_name, surname, code }) {
			let name = "";
			if (first_name) {
				name = name + first_name;
			}

			if (surname) {
				name = name + " " + surname;
			}

			//   if(code)
			//   {
			//     name = name + ` (${code})`;
			//   }

			return `${name}`;
		},
		limitText(count) {
			return `and ${count} other user(s)`;
		},
		limitTextCOAType(count) {
			return `and ${count} other coa-type(s)`;
		},
    }
}

</script>